export class ButtonLayoutType {
    public static LINK: "link";
    public static DROPDOWN: "dropdown";
    public static ICON: "icon";
}